 <template>
  <v-card>
    <v-toolbar dense color="grey lighten-3" flat>
      <v-icon>mdi-magnify</v-icon>
      <v-toolbar-title>Intermediary Helplist</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn text icon @click="closeDialog">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card-text>
      <v-flex xs12>
        <form data-vv-scope="queryIntermediaryForm">
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap>
                        <v-flex lg6 xs12>
                          <v-text-field
                            data-vv-scope="queryIntermediaryForm"
                            v-model="filtersIntermediary.inter"
                            :label="filtersIntermediaryLabel.inter"
                            :error-messages="errors.collect('inter')"
                            data-vv-name="inter"
                            :data-vv-as="filtersIntermediaryLabel.inter"
                          ></v-text-field>
                        </v-flex>
                        <v-flex lg6 xs12>
                          <v-text-field
                            data-vv-scope="queryIntermediaryForm"
                            v-model="filtersIntermediary.intermediaryName"
                            :label="filtersIntermediaryLabel.intermediaryName"
                            :error-messages="errors.collect('intermediaryName')"
                            data-vv-name="intermediaryName"
                            :data-vv-as="filtersIntermediaryLabel.intermediaryName"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                  <v-card-actions right>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                    <v-btn color="primary" text @click.prevent="doFilters">Apply Filters</v-btn>
                  </v-card-actions>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </form>
      </v-flex>
      <v-flex v-if="this.headerInfo === 'header2'" xs12 class="mt-2">
        <v-data-table
          :headers="intermediaryHeaders2"
          :items="intermediaryItems"
          v-bind:options.sync="paginationIntermediary"
          :footer-props="{'items-per-page-options': itemsPerPage }"
          :server-items-length="totalItemsIntermediary"
          :loading="loading"
          class="elevation-1"
          :no-data-text="noDataText"
        >
          <template v-slot:item="row"
            ><tr>
              <td>{{ row.item.titleName }}</td>
              <td>{{ row.item.name }}</td>
              <td>{{ row.item.address1 }}</td>
              <td style="text-align: center">
                <v-btn text icon color="primary" type="submit" @click.prevent="assignIntermediary(row.item)">
                  <v-icon>mdi-content-copy</v-icon>
                </v-btn>
              </td>
            </tr></template
          >
        </v-data-table>
      </v-flex>
      <v-flex v-else xs12 class="mt-2">
        <v-data-table
          :headers="intermediaryHeaders"
          :items="intermediaryItems"
          v-bind:options.sync="paginationIntermediary"
          :footer-props="{'items-per-page-options': itemsPerPage }"
          :server-items-length="totalItemsIntermediary"
          :loading="loading"
          class="elevation-1"
          :no-data-text="noDataText"
        >
          <template v-slot:item="row"
            ><tr>
              <td>{{ row.item.inter }}</td>
              <td>{{ row.item.name }}</td>
              <td style="text-align: center">
                <v-btn text icon color="primary" type="submit" @click.prevent="assignIntermediary(row.item)">
                  <v-icon>mdi-content-copy</v-icon>
                </v-btn>
              </td>
            </tr></template
          >
        </v-data-table>
      </v-flex>
    </v-card-text>
  </v-card>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'

export default {
  data() {
    return {
      actionName: '',
      filtersIntermediaryLabel: {
        inter: 'Intermediary',
        intermediaryName: 'Name'
      },
      filtersIntermediary: {
        inter: undefined,
        intermediaryName: undefined,
        group: undefined,
        interGrps: undefined,
        perDebtTran: undefined
      },
      intermediaryItems: [],
      totalItemsIntermediary: 0,
      intermediaryHeaders: [
        { text: 'Intermediary.', align: 'left', value: 'inter' },
        { text: 'Name', value: 'name' },
        { text: 'Action', align: 'center', sortable: false, value: '' }
      ],
      intermediaryHeaders2: [
        { text: 'Title Name', align: 'left', value: 'titleName' },
        { text: 'Insured Name', value: 'name' },
        { text: 'Address 1', value: 'address1' },
        { text: 'Action', align: 'center', sortable: false, value: '' }
      ],
      paginationIntermediary: {
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5
      }
    }
  },
  mounted() {
    this.doClearFilters()
  },
  methods: {
    closeDialog() {
      this.filtersIntermediary.inter = ''
      this.filtersIntermediary.intermediaryName = ''
      this.$emit('close')
    },
    doClearFilters() {
      this.filtersIntermediary.inter = ''
      this.filtersIntermediary.intermediaryName = ''
      this.filtersIntermediary.group = this.param
      this.filtersIntermediary.interGrps = this.interGrps
      if (this.perDebtTran !== '') {
        this.filtersIntermediary.perDebtTran = this.perDebtTran
      }
      this.fetchIntermediaryData()
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll('queryIntermediaryForm').then((result) => {
        if (result) {
          this.paginationIntermediary.page = 1
          this.filtersIntermediary.group = this.param
          this.filtersIntermediary.interGrps = this.interGrps
          this.fetchIntermediaryData()
        }
      })
    },
    assignIntermediary(data) {
      this.$emit('assign-intermediary', data.inter)
      this.$emit('assign-intermediary-data', data)
      this.$emit('close')
    }
  },
  computed: {},
  watch: {
    'paginationIntermediary': function (value) {
      this.filtersIntermediary.interGrps = this.interGrps
      this.fetchIntermediaryData()
    },
    param: function (value) {
      this.doClearFilters()
    }
  },
  mixins: [TableConst.default, commonAjaxMixin],
  props: {
    param: {
      type: String,
      default: ''
    },
    headerInfo: {
      type: String,
      default: ''
    },
    interGrps: {
      type: String,
      default: undefined
    },
    perDebtTran: {
      type: String,
      default: ''
    }
  }
}
</script>
